import React from 'react';
import { StringColumn, CustomColumn } from 'baseui/data-table';
import { Button } from 'baseui/button';
import { useStyletron } from 'baseui';
import _get from 'lodash/get';
import { EMPTY_STRING } from 'commons-ui';
import downloadImg from 'commons-ui/src/assets/misc/download.png';
import StatusCell from './StatusCell';
import { LIST_COL_NAMES as COL_NAMES } from '../constants';

export const columnConfigs = [
	CustomColumn({
		title: 'Status',
		maxWidth: 120,
		mapDataToValue: (data: any): { status: string } => ({
			status: String(_get(data, COL_NAMES.STATUS, EMPTY_STRING))
		}),
		renderCell: StatusCell
	}),
	StringColumn({
		title: 'Created At',
		maxWidth: 180,
		mapDataToValue: (data: any): string => {
			const date: string | undefined = _get(data, COL_NAMES.CREATED_AT);
			return date ? new Date(date).toLocaleString() : EMPTY_STRING;
		}
	}),
	StringColumn({
		title: 'Updated At',
		maxWidth: 180,
		mapDataToValue: (data: any): string => {
			const date: string | undefined = _get(data, COL_NAMES.UPDATED_AT);
			return date ? new Date(date).toLocaleString() : EMPTY_STRING;
		}
	}),
	CustomColumn({
		title: 'Result',
		maxWidth: 140,
		mapDataToValue: (data: any): { url: string } => ({
			url: String(_get(data, COL_NAMES.DOWNLOAD_URL, EMPTY_STRING))
		}),
		renderCell: ({ value }) => {
			const [css] = useStyletron();
			const handleClick = () => {
				if (value.url) {
					window.open(value.url, '_blank', 'noopener,noreferrer');
				}
			};
			return value.url ? (
				<Button onClick={handleClick} size='mini' kind='tertiary'>
					<img className={css({ height: '20px', width: '20px' })} src={downloadImg} alt='download' />
				</Button>
			) : (
				<span>-</span>
			);
		}
	})
];
